var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12","xs":"12"}},[_c('TablePlaylist',{attrs:{"showTitle":true}})],1),(false)?_c('v-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('v-btn',{on:{"click":function($event){return _vm.createItem()}}},[_vm._v("Neu erstellen")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }